// 商品一覧のバリエーション画像の切り替え
window.setupImageSwitcher = function() {
  
  // #ProductGridContainerまたは.card__variant_chipsが存在するか確認
  if (!document.querySelector('#ProductGridContainer') && !document.querySelector('.card__variant_chips')) return;
  const parentElement = document.querySelector('#ProductGridContainer') || document.querySelector('#MainContent');

  if (parentElement) {
      parentElement.addEventListener('click', function(event) {
          const clickedElement = event.target;

          // クリックされた要素が期待するimgタグであるか確認
          if (clickedElement.tagName === 'IMG' && clickedElement.closest('.card__variant_chips')) {
              const closestCard = clickedElement.closest('.grid__item') || clickedElement.closest('.swiper-slide');
              if (!closestCard) return;

              const mainImage = closestCard.querySelector('.card_media_image ');
              if (mainImage) {
                  mainImage.src = clickedElement.dataset.productimage;
                  mainImage.srcset = clickedElement.dataset.productimage;
              }

              const secondaryImage = closestCard.querySelector('.card_media_image2');
              if (secondaryImage) {
                  secondaryImage.src = clickedElement.dataset.productimage;
                  secondaryImage.srcset = clickedElement.dataset.productimage;
              }

              const allThumbs = closestCard.querySelectorAll('.card__variant_chips img');
              allThumbs.forEach(thumb => thumb.classList.remove('current'));
              clickedElement.classList.add('current');
          }
      });
  }
}
setupImageSwitcher();

//フェードイン
function fadeInOnScroll() {
  $(".fade-in").each(function () {
    var elementTop = $(this).offset().top;
    var windowBottom = $(window).scrollTop() + $(window).height();

    if (windowBottom > elementTop + 200) {
      $(this).addClass("show");
    }
  });
}

//フェードイン[商品]
  const items = document.querySelectorAll(".highlight-section .grid__item");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          entry.target.classList.add("fade-in");
        }, index * 400); // 0.2秒ごとに遅延
      }
    });
  }, { threshold: 0.1 });

  items.forEach(item => observer.observe(item));

fadeInOnScroll(); // 初回チェック
$(window).on("scroll", fadeInOnScroll); // スクロール時に実行

// FAQ
var dtElements = document.querySelectorAll('.faqWrap dt');
dtElements.forEach(function(element) {
  element.addEventListener('click', function(event) {
      event.target.classList.toggle('open');
  });
});

// ヘッダースティッキー
if(document.querySelector('.sticky-header_all') != null){
	const sticky_header_all = document.querySelector('.sticky-header_all');
	const sticky_padding = document.querySelector('.sticky_padding');
	let sticky_header_allTop = sticky_header_all.getBoundingClientRect();
	let sticky_header_allTop_position = sticky_header_allTop.top + window.pageYOffset;
	let sticky_header_all_height = sticky_header_all.clientHeight;
	let sticky_header_Animation = function() {
		let header_scroll_position = window.pageYOffset;
		if(header_scroll_position > sticky_header_allTop_position){
  		sticky_header_all.classList.add('sticky_on');
		sticky_padding.style.paddingTop = sticky_header_all_height + "px";
        sticky_padding.classList.add('sticky_on');
 		}  else {
  	sticky_header_all.classList.remove('sticky_on');
		sticky_padding.style.paddingTop = "0";
        sticky_padding.classList.remove('sticky_on');
 	}
	}
	window.addEventListener('scroll', sticky_header_Animation);
}


// フッターTOPに戻る
if(document.getElementById("side_to_top_btn_sec") != null){
	const pageTop =  document.getElementById('side_to_top_btn_sec');
	const pageTopBtn1 =  document.getElementById('side_to_top_btn');
	let Animation = function() {
	//アイコン位置取得

	//要素の位置座標を取得
	let rect = pageTop.getBoundingClientRect();
	//topからの距離
	let scrollTop = rect.top + window.pageYOffset;

	if(scrollTop > 600){
		pageTop.classList.add('show');
		}  else {
		pageTop.classList.remove('show');
		}
	}
	window.addEventListener('scroll', Animation);
	pageTopBtn1.addEventListener("click", scroll_top);
}


// フッターTOPに戻る
if(document.getElementById("footer_to_top_btn") != null){
	const pagetopBtn = document.querySelector('#footer_to_top_btn');
	pagetopBtn.addEventListener("click", scroll_top);
};

function scroll_top() {
	window.scrollTo(0, 0);
}
  


// 別ホストのリンクを_blankで開く
window.addEventListener('DOMContentLoaded', function() {
  const links = document.links;
  const linksLength = links.length;
  for (let i = 0; i < linksLength ; i++) {
	if (links[i].hostname !== window.location.hostname) {
	  links[i].target = '_blank';
	  links[i].rel = 'noreferrer noopener';
	}
  }
});

// multiGridマウススクロール

jQuery.prototype.mousedragscrollable = function () {
  let target;
  $(this).each(function (i, e) {
    $(e).on("mousedown", function (event) {
      event.preventDefault();
      target = $(e);
      $(e).data({
        down: true,
        move: false,
        x: event.clientX,
        y: event.clientY,
        scrollleft: $(e).scrollLeft(),
        scrolltop: $(e).scrollTop(),
      });
      return false;
    });

    $(e).on("mousemove", function (event) {
      if ($(e).data("down")) {
        event.preventDefault();
        let move_x = $(e).data("x") - event.clientX;
        let move_y = $(e).data("y") - event.clientY;
        if (move_x !== 0 || move_y !== 0) {
          $(e).data("move", true);
        } else {
          return;
        }
        $(e).scrollLeft($(e).data("scrollleft") + move_x);
        $(e).scrollTop($(e).data("scrolltop") + move_y);
        return false;
      }
    });

    $(e).on("mouseup", function (event) {
      if ($(e).data("down")) {
        $(e).data("down", false);
        return false;
      }
    });

    $(e).click(function (event) {
      if ($(e).data("move")) {
        return false;
      }
    });
  });
};


  $(".multiGrid").mousedragscrollable();


	//商品詳細ページのタブ切り替え
  $(function(){ 
		//$('.descriptionTab')が存在する場合に下記を実行
		if($('.descriptionTab').length){
			//$('.descriptionTab .tabContent--A')が存在する場合、1番目のtab_containerの中身に移動させる
			if($('.descriptionTab .tabContent--A').length){
				$('.descriptionTab .tabContent--A').appendTo($('.descriptionTab .tab__container.--A'));
			}
			//$('.descriptionTab .tabContent--B')が存在する場合、2番目のtab_containerの中身に移動させる
			if($('.descriptionTab .tabContent--B').length){
				$('.descriptionTab .tabContent--B').appendTo($('.descriptionTab .tab__container.--B'));
			}
		}
		
    $('.descriptionTab .tab__head span').click(function () { // クリックイベントを設定する
      $(this).addClass('is-active'); // クリックされたタブをアクティブにする
      $(this).siblings().removeClass('is-active'); // 兄弟要素のアクティブを解除する
      $(this).closest('.tab__head').next('.tab__containerWrap').children('.tab__container').eq($(this).index()).addClass('is-active'); // クリックされたタブに対応するコンテンツを表示する
      $(this).closest('.tab__head').next('.tab__containerWrap').children('.tab__container').not(':eq(' + $(this).index() + ')').removeClass('is-active'); // クリックされたタブ以外のコンテンツを非表示にする
    });
  });


//サイドメニュー
//アコーディオンボタン
$(function(){
	$('.accordionButton').click(function(){
		if ($(this).attr('aria-expanded') == 'false') {
			$(this).attr('aria-expanded', true);
			$(this).next().slideDown();
		} else {
				$(this).attr('aria-expanded', false);
				$(this).next().slideUp();
		}
	});
});

////header-typeE
// ナビゲーション 子要素展開
$(function() {
	var ua = navigator.userAgent;
	// タブレット・スマートフォン時
	if ((ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0) && ua.indexOf('Mobile') > 0||ua.indexOf('iPad') > 0) {
		$('.hasChildren > a').on('mouseenter touchstart', function(){
			$(this).toggleClass('open');
			$(this).next('ul,.megaMenu').toggleClass('open');
			return false;
		}).on('mouseleave touchend', function(){
					return false;
		});
		$('.hasChildren .hasChildren--close > a').on('mouseenter touchstart', function(){
			$(this).parents('ul').removeClass('open').prev('a').removeClass('open');
			return false;
		});

	}else{
	// PC時
		$('.hasChildren').hover(function() {
			$(this).children('a').addClass('open');
			$(this).children('ul,.megaMenu').addClass('open');
		}, function() {
			$(this).children('a').removeClass('open');
			$(this).children('ul,.megaMenu').removeClass('open');
		});
	}
});

// 検索ランキングキーワード
$(function() {
  // テキストボックスにフォーカス時、フォームの背景色を変化
  $('.search-header__form input[type="product"]')
    .focusin(function(e) {
      $(this).parents().next('.keywordRanking__toggle').addClass('open');
    })
    .focusout(function(e) {
      setTimeout(function(){
        $('.keywordRanking__toggle.open').removeClass('open');
      },200);
    });
});

//user-guide用
$(document).on("click", ".hasChildren--clickSP > h2", function () {
  var windowWidth = $(window).width();
  if (windowWidth < 1001) {
    var next = $(this).next();
    if ($(this).hasClass("open")) {
      $(this).removeClass("open");
      next.removeClass("open");
      next.slideUp();
    } else {
      const all = $(this)
        .parents("li")
        .parents()
        .parents(".gNav")
        .find(".hasChilds > span");
      all.removeClass("open");
      all.next().removeClass("open").slideUp(0);
      $(this).addClass("open");
      next.addClass("open").slideDown();
    }
    return false;
  }
});